<template>
    <span v-if="$verify.is_cit()">
        <v-chip-group column multiple selected-class="text-primary my-0"
            v-model="contexts"
            @update:modelValue="onChangeContext" >
            <v-chip label v-for="f in StateAuthenticatedUser.get_filiais" :key="f.id"
                :filter="false"
                :value="f" class="mx-1">
                {{ f.filial_codtipocurso_label }}
            </v-chip>
        </v-chip-group>
    </span>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
    data:()=>({
        contexts:[]
    }),
    mounted(){
        // inicializa as filiais do usuário
        this.contexts = this.StateUserFiliais
    },
    methods:{
        ...mapActions(['GetAgendaLabsEspacos']),
        ...mapMutations(['setUserFiliais']),
        onChangeContext(value){
            this.setUserFiliais(value)
        }
    },
    computed:{
        ...mapGetters(['StateAuthenticatedUser', 'StateUserFiliais'])
    },
    watch:{
        StateUserFiliais(v){
            this.contexts = v
        }
    }
}
</script>